<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tipo di distribuzione"
        v-model="implant.distribution_system"
        :options="['Verticale a colonne montanti', 'Orizzontale a zone', 'Canali d\'aria']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Coibentazione rete di distribuzione"
        v-model="implant.distribution_system_net"
        :options="['Assente', 'Presente']"
      />
    </div>

    <Sub title="Vasi di espansione" tag="VX" v-model:elements="implant.expansion_vessels" v-slot="slotProps" :codes="implant.codes">
      <Vessel :element="slotProps.element" />
    </Sub>

    <Sub title="Pompe" tag="PO" v-model:elements="implant.pumps" v-slot="slotProps" :codes="implant.codes">
      <Pump :element="slotProps.element" />
    </Sub>
  </div>
</template>
  
<script>
import Vessel from './_6-distribution/vessel'
import Pump from './_6-distribution/pump'

export default {
  components: {
    Vessel,
    Pump
  },

  props: {
    implant: Object
  },
  emits: ['update:implant']
}
</script>